import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export function useDictionariesQuery() {
  return useQuery({
    queryKey: ["dictionaries"],
    queryFn: () => api.get("/dictionaries"),
    staleTime: 1000 * 60 * 60,
  });
}

export function useAddDictionaryValueMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }) => api.post(`/dictionaries/${key}`, { value }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["dictionaries"] });
    },
  });
}
